import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Herosection1 from '../../widgets/herosection/herosection5';
import OwlCarousel from 'react-owl-carousel';
import { Helmet } from 'react-helmet';
window.fn = OwlCarousel;

class Index7 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
  }
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  openModal() {
    this.setState({ isOpen: true })
  }

  head() {
    return (
      <Helmet>
        <title>Falendi | Software & Innovation by Experts</title>
        <meta name="description" content="Falendi Platform" />
        <meta name="keywords" content="Digital, Data, OCR" />
        <meta name="author" content="Falendi Team" />
        <link rel="canonical" href="" />
      </Helmet>
    );
  }

  render() {
    return (
      <div>
        {this.head()}
        <section className="p-0 py-4">
          <div className="container">
            <Herosection1 />
          </div>
        </section>

      </div>

    );
  }
}

export default Index7;